module.exports = require("fork-ts-checker-notifier-webpack-plugin");